import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND = window.location.origin;
const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("portal_token");
    const saved = localStorage.getItem("portal_customer");
    if (token && saved) {
      try { setCustomer(JSON.parse(saved)); } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${BACKEND}/api/portal/auth/login`, { email, password });
    localStorage.setItem("portal_token", res.data.token);
    localStorage.setItem("portal_customer", JSON.stringify(res.data.customer));
    setCustomer(res.data.customer);
    return res.data;
  };

  const register = async (data) => {
    const res = await axios.post(`${BACKEND}/api/portal/auth/register`, data);
    localStorage.setItem("portal_token", res.data.token);
    localStorage.setItem("portal_customer", JSON.stringify(res.data.customer));
    setCustomer(res.data.customer);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("portal_token");
    localStorage.removeItem("portal_customer");
    setCustomer(null);
  };

  const getToken = () => localStorage.getItem("portal_token");

  return (
    <PortalAuthContext.Provider value={{ customer, login, register, logout, getToken, loading }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export const usePortalAuth = () => useContext(PortalAuthContext);

// Portal API helper
export const portalApi = {
  get: (url) => axios.get(`${BACKEND}/api/portal${url}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("portal_token")}` }
  }),
  post: (url, data, config = {}) => axios.post(`${BACKEND}/api/portal${url}`, data, {
    ...config,
    headers: { Authorization: `Bearer ${localStorage.getItem("portal_token")}`, ...(config.headers || {}) }
  }),
};
